import getStore from '../store/store';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { QuickStepsLoadState } from '../store/schema/QuickStepsLoadState';
import { getQuickStepsLoadState } from './getQuickStepsLoadState';

export function getQuickStepsRunOnce(mailboxInfo: MailboxInfo): boolean {
    if (getQuickStepsLoadState(mailboxInfo) === QuickStepsLoadState.Loaded) {
        const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
        const quickStepsConfig = getStore().quickStepsStoreMap.get(accountKey);
        return quickStepsConfig?.runOnce ?? false;
    } else {
        return false;
    }
}
